var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgLocationDark = function SvgLocationDark(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_x36_4px_boxes"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    width: 64,
    height: 64
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Production"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#565D64",
    d: "M31.4301,15.9906c-3.5909,0-6.5001,2.9097-6.5001,6.4999c0,3.5902,2.9092,6.5009,6.5001,6.5009 s6.5001-2.9102,6.5001-6.5009C37.9302,18.9003,35.021,15.9901,31.4301,15.9906z M31.4301,3.9912 C20.125,3.9917,10.9294,13.2183,10.9294,24.5579c0,11.8336,7.2844,19.4617,20.5006,36.4327 C44.5784,44.09,51.9307,36.4276,51.9307,24.5579C51.9307,13.2183,42.7341,3.9917,31.4301,3.9912z M15.7666,24.4944 c0-8.6644,7.0266-15.7133,15.6635-15.7136c8.637,0.0004,15.6635,7.0492,15.6635,15.7136c0,9.4866-5.9198,16.0352-15.6635,28.5758 C21.6747,40.5199,15.7666,33.9659,15.7666,24.4944z"
  })))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgLocationDark);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/location-dark.bb7cdbe02ef0abba0b05ffc9bd6532fa.svg";